const debitCharges = [
  { id: 1, column: 'transit_charge', label: 'Transit Delay', readOnly: true },
  { id: 2, column: 'shortage_charge', label: 'Shortage', readOnly: true },
  { id: 3, column: 'damage_charge', label: 'Damage', readOnly: true },
  { id: 4, column: 'carton_damage_charge', label: 'Carton Damage', readOnly: true },
  { id: 5, column: 'sla_breach', label: 'SLA Delay', readOnly: true },
];

export default debitCharges;
